module.exports = "/_next/static/images/SecurityAndPrivacy-9fc918ec106fed379b78af2f5ad4d07a.webp";